import axios from 'axios'
import { store } from '../store/store'
import router from '../router'

if (document.URL.indexOf('localhost') > 0) {
  axios.defaults.baseURL = 'http://api.tasin.com.tr/api'
} else if (document.URL.indexOf('tasin') > 0) {
  axios.defaults.baseURL = 'https://api.tasin.com.tr/api'
}

axios.interceptors.request.use(request => {
  //request.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
  const token = store.getters.getAccessToken
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  return request
})

axios.interceptors.response.use(response => response, error => {
  const { status, data } = error.response;

  if (status >= 500) {
    console.log('Hata')
  }
  if (status === 401 && !store.getters.isAuthenticated) {
    router.push('/session/login')
  } else if (status === 401 && store.getters.isAuthenticated) {
    router.push('/default/dashboard')
  } else if (status == 400) {
    console.log(data)
  }

  return Promise.reject(error.response)
})
